import React from 'react';
import { Download, ArrowRight } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { lessons } from '../mock';
import { toast } from 'sonner';

const Curriculum = () => {
  return (
    <section id="programma" className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 scroll-mt-20">
      <div className="max-w-3xl reveal">
        <span className="label-mono">// COSA IMPARERAI</span>
        <h2 className="mt-4 font-display font-semibold text-white text-3xl md:text-5xl leading-tight">
          Non imparerai solo a utilizzare il software, qui imparerai a <span className="gold-text">produrre risultati.</span>
        </h2>
        <p className="mt-6 text-neutral-400 leading-relaxed">
          Alla fine del percorso avrai le competenze per produrre le tipologie di contenuti che i clienti e gli studi
          professionali richiedono oggi. Avrai un metodo professionale e saprai gestire un progetto come un
          professionista, e questo farà tutta la differenza del mondo.
        </p>
        <p className="mt-3 text-neutral-500 italic text-sm">ps: fidati di uno che ci lavora ogni giorno!</p>
      </div>

      <h3 className="mt-16 mb-8 font-display font-semibold text-white text-2xl md:text-3xl reveal">
        Un metodo. Una professione. <span className="gold-text">Risultati concreti</span>
      </h3>

      <div className="reveal">
        <Accordion type="single" collapsible defaultValue="item-0" className="space-y-3">
          {lessons.map((l, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-white/10 rounded-xl px-5 md:px-6 bg-[var(--uv-surface)] data-[state=open]:border-[var(--uv-gold)]/40 transition-colors"
            >
              <AccordionTrigger className="hover:no-underline py-5">
                <div className="flex items-center gap-5 text-left">
                  <span className="font-display font-bold text-2xl text-[var(--uv-gold)] w-10 shrink-0">{l.n}</span>
                  <div>
                    <div className="font-mono-uv text-[0.68rem] tracking-widest text-neutral-500">/ {l.tag}</div>
                    <div className="font-display font-medium text-white text-lg md:text-xl mt-1">{l.title}</div>
                  </div>
                </div>
              </AccordionTrigger>
              <AccordionContent className="text-neutral-400 leading-relaxed pl-[3.75rem] pb-6">
                {l.text}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>

      {/* Download programma */}
      <div className="mt-14 rounded-2xl border border-white/10 bg-gradient-to-br from-[var(--uv-surface)] to-[#0c0c0e] p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-6 reveal">
        <div>
          <h3 className="font-display font-semibold text-white text-2xl md:text-3xl">Vuoi vedere tutto nel dettaglio?</h3>
          <p className="mt-2 text-neutral-400">Scarica il programma delle lezioni completo in PDF, diviso per argomento.</p>
        </div>
        <button
          onClick={() => toast.success('Programma in arrivo!', { description: 'Ti invieremo il PDF completo via email.' })}
          className="inline-flex items-center gap-2 px-7 py-4 rounded-full bg-[var(--uv-gold)] text-[#0c0c0e] font-semibold hover:bg-[var(--uv-gold-soft)] transition-colors shrink-0"
        >
          <Download size={18} /> Scarica il programma
        </button>
      </div>
    </section>
  );
};

export default Curriculum;
